import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import {Typeahead} from 'react-bootstrap-typeahead';
import SvgIcon from 'react-icons-kit';
import {checkmark} from 'react-icons-kit/icomoon/checkmark';
import {cross} from 'react-icons-kit/icomoon/cross';
import Help from '../../generics/help';

var Config = require('../../../config');
var session = sessionStorage.getItem('health_facilities_name');

class LabelConfirm extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.getUnitComponent = this.getUnitComponent.bind(this);
		this.validateInput = this.validateInput.bind(this);
		this.loadComponent = this.loadComponent.bind(this);
		this.verify = this.verify.bind(this);
		this.new = this.new.bind(this);

		this.state = {
			label:"",
			unit:"",
			components:[],
			unit_id:"",
		}
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		
		setTimeout(()=>{
			document.getElementById('label').focus();
		}, 800);
		
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		document.getElementById(e.target.name).classList.remove('error');
	}

	new(e){
		e.preventDefault();
		this.setState({
			label:"",
			unit:"",
			components:[],
			unit_id:"",
		})
		this._typeahead.getInstance().clear();
		document.getElementById('label').focus();
	}

	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		if(e.target.name === 'unit'){
      			this.getUnitComponent(e.target.name);
      		}
      		
      		document.getElementById('unit').classList.remove('error');
			document.getElementById('code_component').classList.remove('error');
      	
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);
    		
    		if(form.elements[index + 1] !== undefined){
    			form.elements[index + 1].focus();
    		}
      	}
   	}

	getUnitComponent(){
   		if(this.state.unit !== ""){
   			this.props.waiting.handleShow('Cargando...');
	   		fetch(Config.default.apiGateway.URL+'units/to_confirm_label?unit_number='+this.state.unit+
	   			'&health_facilities_id='+sessionStorage.getItem('health_facilities_id'), {
	   			method: 'GET',
	   			headers: new Headers({
	   				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
	   				'Accept'		: 'application/json',
	   				'Content-Type'	: 'application/json'
	   			})
	   		}).then(res => {
	   			this.props.waiting.handleClose();
	   			if(res.ok){
	   				return res.json();
	   			}else{
	   				res.text().then((msg)=>{
	   					swal('Error', msg, 'error');
	   				});
	   			}
	   		}).then(response => {
	   			if(response !== undefined){
   					this._typeahead.getInstance().clear();
	   				this.setState({components: response});
	   				
	   			}
	   		});

   		}else{
   			swal('Error', 'Debe de ingresar un número de unidad', 'error');
   		}
   	}

   	loadComponent(e){
   		if(e.length > 0){
   			if(e[0].status !== 'BLOQUEADA'){
   				this.setState({
	   				unit_id:e[0].unit.id
	   			});

	   			setTimeout(()=>{
	   				this.verify();
	   			}, 500);
	   			
	   			document.getElementById('code_component').classList.remove('error');
   			}else{
   				swal('Error', 'El componente que intenta seleccionar se encuentra bloqueado', 'error');
				this._typeahead.getInstance().blur();
				this._typeahead.getInstance().clear();
				this._typeahead.getInstance().focus();
	   			
   			}
   		}
   	}

   	verify(e){
   		if(e !== undefined) e.preventDefault();

   		var incompleto = false;
   		if(this.state.unit_id === ""){
   			document.getElementById('unit').classList.add('error');
			document.getElementById('code_component').classList.add('error');
			incompleto = true;	
		}

		if(this.state.label === ""){
			document.getElementById('label').classList.add('error');
			incompleto = true;	
		}

		if(!incompleto){
			document.getElementById('unit').classList.remove('error');
			document.getElementById('code_component').classList.remove('error');
			document.getElementById('label').classList.remove('error');

			fetch(Config.default.apiGateway.URL+'units/label_confirmation?extraction_label='+this.state.label+
				'&unit_id='+this.state.unit_id, {
				method:'post',
				headers:new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					if(response){
						document.getElementById('label_ok').style.display = 'block';
						document.getElementById('unit_ok').style.display = 'block';
						document.getElementById('label_no').style.display = 'none';
						document.getElementById('unit_no').style.display = 'none';

						document.getElementById('label_ok').style.display = 'none';
						document.getElementById('unit_ok').style.display = 'none';
						document.getElementById('label').focus();
						this._typeahead.getInstance().clear();

						this.setState({
							label:"",
							unit:"",
							components:[],
							unit_id:"",
						})
					/*	setTimeout(()=>{
							swal({
					          	title: "Correcto",
					          	text: 'Confirmación correcta',
					          	type: 'success',
					        }, (isConfirm)=>{
					            if (isConfirm) {
					             	document.getElementById('label_ok').style.display = 'none';
									document.getElementById('unit_ok').style.display = 'none';
									document.getElementById('label').focus();
									this._typeahead.getInstance().clear();

									this.setState({
										label:"",
										unit:"",
										components:[],
										unit_id:"",
									})
					            }
					        });
						}, 1000);*/
							
					}else{
						document.getElementById('label_ok').style.display = 'none';
						document.getElementById('unit_ok').style.display = 'none';
						document.getElementById('label_no').style.display = 'block';
						document.getElementById('unit_no').style.display = 'block';

						setTimeout(()=>{
							swal({
					          	title: "Error",
					          	text: 'Unidad Incorrecta',
					          	type: 'error',
					        }, (isConfirm)=>{
					            if (isConfirm) {
					             	document.getElementById('label_no').style.display = 'none';
									document.getElementById('unit_no').style.display = 'none';
									document.getElementById('label').focus();
									this._typeahead.getInstance().clear();

									this.setState({
										label:"",
										unit:"",
										components:[],
										unit_id:"",
									})
					            }
					        });
						}, 1000);

					}
				}
			})
		}else{
   			swal('Error', 'Campos incompletos', 'error');

   		}
   	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.process.MAIN')} ->
						Confirmación de Etiqueta
					</h5>
				</div>

            		
				<Help 
					{...this.props}
	                menu={"help_processed"} 
	                submenu={"help_label_confirmation"}  />
				<form>
					<div className="col-xs-12 col-sm-offset-4 col-sm-3" style={{marginTop:'10%'}}>
						<div className="col-xs-11">
							<span>Etiqueta de Extracción</span>
							<input type="password" name="label" id="label" value={this.state.label} autoComplete="none"
								onChange={this.handleChange} className="form-control" onKeyPress={this.validateInput} />
							
						</div>
						<div className="col-xs-1" style={{marginTop:'17px'}}>
							<div id="label_ok" style={{color:"green", display:"none", width:"33.3%"}}>
								<SvgIcon icon={checkmark} style={{paddingTop:"3px"}}/>
							</div>
							<div id="label_no" style={{color:"red", display:"none", width:"33.3%"}}>
								<SvgIcon icon={cross} style={{paddingTop:"3px"}}/>
							</div>
						</div>
						<div className="col-xs-6 form-group">
							<span>Unidad</span>
							<input type="text" name="unit" id="unit" value={this.state.unit}
								onChange={this.handleChange} className="form-control" onKeyPress={this.validateInput}  />
						</div>
						<div className="col-xs-5 form-group">
							<span className="span-min">No. Componente</span>
							<Typeahead
					          	labelKey={(option) => `${option.label}`}
					          	minLength={0}
					          	maxLength={50}
					          	inputProps={{
				          			name:"code_component",
				          			required:'required',
				          			id:"code_component"
				          	  	}}
				          	  	id="codeComponent"
					          	options={this.state.components}
					          	onChange={this.loadComponent}
					          	ref={ref => this._typeahead = ref}
					          	isLoading={this.state.isLoading}
					          	selectHintOnEnter={true}
					          	delay={600}
					          	paginationText="Mostrar mas resultados..."
					        />
						</div>
						<div className="col-xs-1 form-group" style={{marginTop:'17px'}}>
							<div id="unit_ok" style={{color:"green", display:"none", width:"33.3%"}}>
								<SvgIcon icon={checkmark} style={{paddingTop:"3px"}}/>
							</div>
							<div id="unit_no" style={{color:"red", display:"none", width:"33.3%"}}>
								<SvgIcon icon={cross} style={{paddingTop:"3px"}}/>
							</div>
						</div>
						<div className="col-xs-12">
							<div className="col-xs-6">
								<button className="btn btn-danger" onClick={this.verify}>Verificar</button>
							</div>
							<div className="col-xs-6">
								<button className="btn btn-info" onClick={this.new}>Nuevo</button>
							</div>
						</div>
					</div>
				</form>
			</div>
		)
	}
} 

export default translate('translations')(LabelConfirm);